module.exports = __webpack_public_path__ + "img/zone-mandibulaire.702e9516.png";